import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/app/[locale]/(public)/not-found.tsx");
